"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function () {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const divider = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const essay = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const portrait = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const quoteBlock = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const strip = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const detailImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_precision_instrument.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_precision_instrument.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_precision_instrument.webp-wvc-sizes",
    alt: "Close-up of surgical instruments used in gynecological procedures"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/forensic_documentation_files.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/forensic_documentation_files.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/forensic_documentation_files.webp-wvc-sizes",
    alt: "Organized medical records and forensic documentation"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/clinical_consultation_room.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/clinical_consultation_room.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/clinical_consultation_room.webp-wvc-sizes",
    alt: "Modern clinical consultation room with professional equipment"
  }];
  const revealBase = "transition-all duration-1000 ease-out will-change-transform";
  const hidden = "opacity-0 translate-y-3";
  const shown = "opacity-100 translate-y-0";
  return <section data-section-id="2740" id="curriculum-e-competenze" className="bg-background text-foreground pt-32 md:pt-40 lg:pt-[160px] pb-24 md:pb-32 lg:pb-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={eyebrow.ref} className={`${revealBase} ${eyebrow.isVisible ? shown : hidden} text-center`}>
          <span className="font-mono text-xs md:text-sm tracking-[0.3em] uppercase text-muted-foreground">
            Esperienza &middot; Professionale
          </span>
        </div>

        {}
        <h2 ref={headline.ref} className={`${revealBase} ${headline.isVisible ? shown : hidden} delay-100 font-default font-light text-center mt-10 md:mt-14 text-foreground leading-[1.02] tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[7.5rem]`}>
          Eccellenza clinica al servizio della <em className="italic font-normal text-primary">salute femminile</em>.
        </h2>

        {}
        <div ref={divider.ref} className={`${revealBase} ${divider.isVisible ? shown : hidden} delay-200 flex justify-center mt-12 md:mt-16`}>
          <Separator className="w-[120px] bg-border" />
        </div>

        {}
        <div className="mt-20 md:mt-28 grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-start">
          {}
          <div ref={essay.ref} className={`${revealBase} ${essay.isVisible ? shown : hidden} lg:col-span-3`}>
            <div className="font-default text-foreground/90 space-y-7 text-lg md:text-[1.125rem] leading-[1.8]">
              <p>
                <span className="float-left font-default text-primary text-[80px] leading-[0.85] pr-3 pt-1 font-normal">
                  I
                </span>
                l Dott. Mirko Colloca dedica la propria carriera alla cura e alla tutela della salute della donna. Specialista in Ginecologia e Ostetricia, il suo percorso professionale è caratterizzato da un costante impegno nella ricerca scientifica e nell'applicazione clinica delle più avanzate tecniche di medicina riproduttiva.
              </p>
              <p>
                La sua attività si focalizza sulla Fisiopatologia della Riproduzione Umana, offrendo percorsi diagnostici e terapeutici personalizzati per le coppie che desiderano intraprendere un cammino verso la genitorialità, garantendo sempre un approccio basato sull'evidenza scientifica e sull'empatia.
              </p>
              <p>
                Oltre all'attività clinica, il Dott. Colloca mette a disposizione la sua profonda competenza in ambito di Ginecologia Forense. Questa specializzazione gli permette di operare come consulente tecnico in contesti legali, garantendo rigore analitico e precisione nella valutazione di casi complessi, sempre nel rispetto dell'etica medica.
              </p>
              <p>
                Ogni consultazione è un atto di responsabilità. Il suo obiettivo è fornire risposte chiare, supporto costante e soluzioni mediche d'eccellenza, ponendo sempre la paziente al centro di ogni decisione clinica.
              </p>
            </div>
          </div>

          {}
          <div ref={portrait.ref} className={`${revealBase} ${portrait.isVisible ? shown : hidden} delay-150 lg:col-span-2 lg:-mr-6 xl:-mr-12`}>
            <div className="relative overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/mirko_colloca_portrait.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/mirko_colloca_portrait.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/mirko_colloca_portrait.webp-wvc-sizes" alt="Ritratto professionale del Dott. Mirko Colloca nel suo studio" loading="lazy" decoding="async" className="w-full h-[520px] md:h-[640px] lg:h-[760px] object-cover" src="https://drmirkocolloca.com/wp-content/uploads/2026/07/csi5nisvwaxak8yp9upg.webp" />
            </div>
            
          </div>
        </div>

        {}
        <div ref={quoteBlock.ref} className={`${revealBase} ${quoteBlock.isVisible ? shown : hidden} mt-24 md:mt-32 lg:mt-[96px] mb-24 md:mb-32 lg:mb-[96px] text-center max-w-4xl mx-auto`}>
          <blockquote className="font-default italic font-light text-foreground leading-[1.2] text-3xl sm:text-4xl md:text-5xl tracking-tight">
            &ldquo;La medicina è scienza, ma la cura è un atto di profonda dedizione umana.&rdquo;
          </blockquote>
          <div className="mt-10 flex items-center justify-center gap-4">
            <span className="block w-10 h-px bg-border" />
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">
              Principio Etico
            </span>
            <span className="block w-10 h-px bg-border" />
          </div>
        </div>

        {}
        <div ref={strip.ref} className={`${revealBase} ${strip.isVisible ? shown : hidden} grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6`}>
          {detailImages.map((image, i) => <div data-index={i} key={i} className="overflow-hidden rounded-lg shadow-md">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="w-full h-72 md:h-80 lg:h-96 object-cover transition-transform duration-700 ease-out hover:scale-[1.03]" />
            </div>)}
        </div>
      </div>
    </section>;
}